$( document ).ready(function() {
    var mySwiper = undefined;
    function initSwiper(){
        var screenWidth = $(window).width();
        if(screenWidth < 885 && mySwiper == undefined) {     
            $('.c-key-info__key-main').addClass('swiper');
            $('.c-key-info__key--list').addClass('swiper-wrapper');
            $('.c-key-info__key--item').addClass('swiper-slide');
            mySwiper = new Swiper('.c-key-info__key-main', {            
                // Optional parameters
                slidesPerView: 'auto',
                spaceBetween: 0,
                grabCursor: true,
                // Pagination progressbar
                pagination: {
                    el: '.c-key-info__key--progress',
                    type: 'progressbar',
                },
            });
        } else if (screenWidth >= 885 && mySwiper != undefined) {
            mySwiper.destroy();
            mySwiper = undefined;
            $('.swiper-wrapper').removeAttr('style');
            $('.swiper-slide').removeAttr('style');
            $('.c-key-info__key-main').removeClass('swiper');
            $('.c-key-info__key--list').removeClass('swiper-wrapper');
            $('.c-key-info__key--item').removeClass('swiper-slide');
        }  
    }

    //Swiper plugin initialization
    initSwiper();

    //Swiper plugin initialization on window resize
    $(window).on('resize', function(){
        initSwiper();        
    });
});